/** Number of days ahead to look for employee availability. */
export const DAYS_TO_LOAD = 15

const pad = (n: number) => String(n).padStart(2, '0')

function localISODateTime(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

function localISODate(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

/** Start of the search window — current local date-time as "YYYY-MM-DDTHH:mm". */
export function getStartDate(): string {
  return localISODateTime(new Date())
}

/** End of the search window — DAYS_TO_LOAD days from today as "YYYY-MM-DD". */
export function getEndDate(): string {
  const d = new Date()
  d.setDate(d.getDate() + DAYS_TO_LOAD)
  return localISODate(d)
}
